import React from "react";
import "./About.scss";
const About = () => {
  return (
    <div className="about  min-h-screen">
      {/* Parent Animation */}
      <div className="flex flex-col justify-center items-center py-20">
        <div className="">
          <h3 class="animate-charcter hover:scale-105 ease-in duration-500">
            {" "}
            ABOUT-ME
          </h3>
        </div>

        {/* About Me Section  */}

        <div className="glass  rounded-md p-5 py-10">
          <div data-aos="zoom-in" className="text-white">
            <div>
              <h1 className="text-3xl text-white font-bold ">
                MD Rokibul Islam
              </h1>
              <p className="special-text text-3xl">
                <b>Full Stack Developer</b>
              </p>
            </div>
          </div>
          <div className="text-white">
            <h1 className="font-bold py-3  text-6xl text-green-400 special-text">
              Experience
            </h1>
            {/* Pixtics */}
            <div className="text-lg">
              <b>Pixtics-</b>
              <i className="font-light pr-3">Full Stack Developer</i>
              <i className="text-sm font-light px-3">May 2023 - Running</i>
              <ul>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  Developed API's with Node.js, Express, Mongoose, MongoDB
                </li>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  Optimized speed of websites for Google PageSpeed Insights
                </li>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  Translated Designs into high-quality code using React,
                  Typescript, Antd, MUI, Tailwind, and Bootstrap.
                </li>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  Collaborated closely with fellow developers, ensuring
                  effective teamwork and streamlined development processes on
                  GitHub.
                </li>
              </ul>
            </div>
            {/* Professional Trainning */}
            <div>
              <h1 className="font-bold py-3  text-6xl text-green-400 special-text">
                Professional Trainning
              </h1>
              <ul>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  <b>Next Level Web Development: </b> <i>Programming Hero</i>{" "}
                  <i className="text-sm font-light px-3">May 2023 - Running</i>
                  <p>
                    <b>Topics: </b>{" "}
                    <span>
                      NextJs, SQL Database, Prisma, CI/CD, Docker, Nginx
                    </span>
                  </p>
                </li>
              </ul>
              <ul>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  <b>MERN Stack : </b> <i>Programming Hero</i>{" "}
                  <i className="text-sm font-light px-3">
                    June 2021 - December 2021
                  </i>
                  <p>
                    <b>Topics: </b>{" "}
                    <span>
                      HTML, CSS, Javascript, React, Firebase, NodeJs, MongoDB
                    </span>
                  </p>
                </li>
              </ul>
            </div>
            {/* Education */}
            <div>
              <h1 className="font-bold py-3  text-6xl text-green-400 special-text">
                Educational Background
              </h1>
              <ul>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  <b>Bachelor of Business Adminstration: </b>{" "}
                  <i>National University, Bangladesh</i>{" "}
                </li>
              </ul>
              <ul>
                <li>
                  <span className="text-green-400 pr-3">❖</span>
                  <b>Higher Secondary School Certificate(Science): </b>{" "}
                  <i>Govt Shaheed Bulbul College</i>
                </li>
              </ul>
            </div>
          </div>
          {/* Skills Section  */}
          <div className="container text-white flex flex-col items-center justify-center">
            <h1 className="text-6xl font-bold p-7 special-text">SKILLS</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 container gap-x-10 gap-y-10">
              <div
                data-aos="fade-up"
                className="hover:bg-slate-800 ease-in duration-200 rounded text-emerald-50 ring-2 shadow-lg shadow-slate-700/100 p-5"
              >
                <h1 className="font-bold  pb-3 text-4xl text-green-400 special-text">
                  Frontend
                </h1>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> HTML
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Javascript
                </li>

                <li className=" list-none">
                  <span className="text-green-400">❖</span> PHP
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> React
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Redux/toolkit/RTK
                  Query
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Typescript
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Wordpress
                </li>
              </div>
              <div
                data-aos="fade-up"
                className="hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-2 shadow-lg shadow-slate-700/100 min-w-[250px] min-h-[200px]"
              >
                <h1 className="font-bold pb-3 text-4xl text-green-400 special-text">
                  Backend
                </h1>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> NodeJS
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> MongoDB
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Express
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Mongoose
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> JWT
                </li>
              </div>
              <div
                data-aos="fade-up"
                className="hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-2 shadow-lg shadow-slate-700/100 min-w-[250px] min-h-[200px]"
              >
                <h1 className="font-bold  pb-3 text-4xl text-green-400 special-text">
                  Design
                </h1>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Tailwind
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Ant Design
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Bootstrap
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> SASS
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Material UI
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Styled Component
                </li>
              </div>
              <div
                data-aos="fade-up"
                className="hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-2 shadow-lg shadow-slate-700/100 min-w-[250px] min-h-[200px]"
              >
                <h1 className="font-bold pb-3 text-4xl text-green-400 special-text">
                  Tools
                </h1>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Linux
                </li>
                <li className="list-none">
                  <span className="text-green-400">❖</span> Git & Github
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Bit Bucket
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> Postman
                </li>
                <li className=" list-none">
                  <span className="text-green-400">❖</span> VS Code
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
